<!-- <template>
  <div class="main_box">
    <div class="table_header">
      <div style="border: none;" class="header">床位号</div>
      <div class="header">姓名</div>
      <div class="header">治疗模式</div>
      <div class="header">开始时间</div>
      <div class="header">下机时间</div>
    </div>
    <div class="table_body">
      <div class="row" v-for="value in 10" :key="value">
        <div class="col">1号床</div>
        <div class="col">张三</div>
        <div class="col">HD+HP</div>
        <div class="col">13:20</div>
        <div class="col">17:20</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'List', // Vue2推荐显式声明组件名
  // 若需要数据可在data中定义，这里保持原逻辑无额外数据
  data() {
    return {
      // 示例：如果后续需要动态渲染数据，可在这里定义
      // bedList: []
    }
  }
}
</script>

<style scoped>
/* 移除SCSS嵌套，改为普通CSS后代选择器 */
.main_box {
  height: 100%;
  width: 100%;
}

.table_header {
  width: 100%;
  height: 0.7rem;
  background-color: var(--color-primary-light-5);
  border-radius: 0.1rem;
  display: flex;
  align-items: center;
  font-size: 0.35rem;
  color: #fff;
}

.header {
  flex: 1;
  text-align: center;
  font-weight: bold;
  border-left: 0.05rem solid #ffffff;
}

.table_body {
  width: 100%;
  height: calc(100% - 0.8rem);
  font-size: 0.35rem;
  margin-top: 0.1rem;
}

.row {
  width: 100%;
  height: 0.7rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.1rem;
  background-color: var(--color-primary-light-5);
  border-radius: 0.1rem;
}

.col {
  flex: 1;
  text-align: center;
}
</style> -->
<template>
  <div class="main_box">
    <div class="table_header">
      <div style="border: none;">床位号</div>
      <div>排队</div>
      <div>姓名</div>
      <div>治疗模式</div>
      <div>预约时间</div>
      <div>签到时间</div>
      <div>开始时间</div>
      <div>预下机时间</div>
    </div>
    <div class="table_body">
      <div class="row" v-for="item in displayData" :key="item.id">
        <div style="border: none;">{{ item.bed_nm }}</div>
        <div>{{ item.task_sort_sign }}</div>
        <div>{{ maskName(item.psn_nm) }}</div>
        <div>{{ item.hdt_flg }}</div>
        <div>{{ item.add_yy_time }}</div>
        <div>{{ item.task_tm_signin | formatting }}</div>
        <div>{{ item.task_tm_start | formatting }}</div>
        <div>{{ item.add_xj_time }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
  name: 'List',
  props: {
    patData: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    formatting(value) {
      if (!value) return '';
      return dayjs(value).format('HH:mm');
    }
  },
  data() {
    return {
      patList: [],//原始数据
      pageSize: 0,// 每页可容纳的行数
      displayData: [],// 最终展示的数据
      cycleTimer: null,// 定时器实例（用于清理）
      currentIndex: 0, // 当前显示数据的索引
    }
  },
  mounted() {
    // 设置定时器，每隔十秒显示下一批数据
    this.cycleTimer = setInterval(this.showNextData, 5000);
  },
  methods: {
    // 姓名脱敏
    maskName(value) {
      if (value) {
        if (value.length === 2) {
          return value.substring(0, 1) + "*"; // 两个字的最后一个字符用*替换
        } else if (value.length === 3) {
          return value.substring(0, 1) + '*' + value.substring(2); // 三个字的将中间的字替换为*
        } else if (value.length > 3) {
          return value.substring(0, 1) + '*'.repeat(value.length - 2) + value.substring(value.length - 1); // 三个字以上的保留首尾两个字，其它的替换为*
        } else {
          return value; // 一个字的姓名不进行处理
        }
      }
    },
    // getDivHeightByClassName() {
    //   if (this.patData.length === 0) {
    //     console.log('patData为空，无需获取row元素高度');
    //     return;
    //   }

    //   const targetElement1 = document.querySelector('.main_box');
    //   const targetElement2 = document.querySelector('.table_header');
    //   const targetElement3 = document.querySelector('.row');

    //   if (!targetElement1) {
    //     console.warn('未找到类名为 main_box 的元素');
    //     return;
    //   }
    //   if (!targetElement2) {
    //     console.warn('未找到类名为 table_header 的元素');
    //     return;
    //   }
    //   if (!targetElement3) {
    //     console.warn('未找到类名为 row 的元素');
    //     return;
    //   }

    //   // 获取不同维度的高度（按需选择）
    //   const clientHeight1 = targetElement1.clientHeight;
    //   const clientHeight2 = targetElement2.clientHeight;
    //   const clientHeight3 = targetElement3.clientHeight;

    //   let patListH = clientHeight1 - clientHeight2;
    //   console.log('patListH：', patListH);
    //   console.log('可容纳row数量：', (patListH / clientHeight3) - 1);
    //   this.pageSize = parseInt((patListH / clientHeight3) - 1)
    //   for (let i = 0; i < this.pageSize; i++) {
    //     this.displayData.push(this.patList[i])
    //   }
    //   this.currentIndex = this.pageSize

    //   this.showNextData()
    // },
    getDivHeightByClassName() {
      if (this.patData.length === 0) {
        console.log('patData为空，无需获取row元素高度');
        return;
      }

      const targetElement1 = document.querySelector('.main_box');
      const targetElement2 = document.querySelector('.table_header');
      const targetElement3 = document.querySelector('.row');

      if (!targetElement1 || !targetElement2 || !targetElement3) {
        console.warn('未找到所需元素');
        return;
      }

      const clientHeight1 = targetElement1.clientHeight; // 容器高度
      const clientHeight2 = targetElement2.clientHeight; // 表头高度
      const clientHeight3 = targetElement3.clientHeight; // row 内容高度（不含 margin）

      // 获取 .row 的 margin-bottom（单位 px）
      const rowStyle = window.getComputedStyle(targetElement3);
      const marginBottom = parseFloat(rowStyle.marginBottom) || 0;

      // 可用于排布 rows 的总高度
      const patListH = clientHeight1 - clientHeight2;

      // 每行实际占用高度 = 内容高 + 下边距
      const rowTotalHeight = clientHeight3 + marginBottom;

      /*
        排满 n 行的占用高度公式：
        n * rowTotalHeight - marginBottom ≤ patListH
        => n ≤ (patListH + marginBottom) / rowTotalHeight
      */
      const maxRows = Math.floor((patListH + marginBottom) / rowTotalHeight);

      this.pageSize = maxRows;

      console.log('patListH：', patListH);
      console.log('row 内容高：', clientHeight3, 'margin-bottom：', marginBottom);
      console.log('可容纳 row 数量：', maxRows);

      // 根据新的 pageSize 展示第一批数据
      this.displayData = [];
      for (let i = 0; i < this.pageSize; i++) {
        if (this.patList[i]) {
          this.displayData.push(this.patList[i]);
        }
      }
      this.currentIndex = this.pageSize;

      // 如果不需要初始化完立刻跳到下一页，建议删除下面这行，
      // 否则 displayData 会被 showNextData 立即覆盖成下一批数据
      // this.showNextData();
    },
    showNextData() {
      // 切片获取下一批数据
      // console.log(this.pageSize);

      this.displayData = this.patList.slice(
        this.currentIndex,
        this.currentIndex + this.pageSize
      );
      // 更新索引
      this.currentIndex += this.pageSize;
      // 如果已经显示完所有数据，从头开始显示
      if (this.currentIndex >= this.patList.length) {
        this.currentIndex = 0;
      }
    }
  },
  watch: {
    patData: {
      immediate: true, // 组件初始化时立即执行一次
      handler(newVal) {
        if (newVal.length > 0) {
          this.patList = newVal
          this.displayData.push(newVal[0])
          console.log(this.displayData);

          // 核心修改：使用$nextTick确保DOM更新完成后再获取元素
          this.$nextTick(() => {
            this.getDivHeightByClassName();
          });
        }
      }
    }
  },
  beforeDestroy() {
    if (this.cycleTimer) {
      clearInterval(this.cycleTimer);
      this.cycleTimer = null;
    }
  },
}
</script>

<style scoped>
.main_box {
  height: 100%;
  width: 100%;
}

.main_box .table_header {
  width: 100%;
  height: 0.7rem;
  background-color: var(--color-primary-light-5);
  border-radius: 0.1rem;
  display: flex;
  align-items: center;
  font-size: 0.35rem;
  color: #ffffff;
}

.main_box .table_header div {
  flex: 1;
  text-align: center;
  font-weight: bold;
  border-left: 0.05rem solid #ffffff;
}

.main_box .table_body {
  width: 100%;
  height: calc(100% - 0.8rem);
  font-size: 0.35rem;
  margin-top: 0.1rem;
}

.main_box .table_body .row {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: var(--color-primary-light-5);
  /* border-bottom: 0.02rem solid #ffffff; */
  margin-bottom: 0.1rem;
  color: #ffffff;
}

.main_box .table_body .row div {
  flex: 1;
  height: 0.7rem;
  /* border-left: 0.05rem solid #ffffff; */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>